(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtee-clinical-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noxtee-proof-metrics')) {
    customElements.define(
      'noxtee-proof-metrics',
      class NoxteeProofMetrics extends HTMLElement {
        connectedCallback() {
          this.numbers = [...this.querySelectorAll('[data-proof-number]')];
          this.hasPlayed = false;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
            this.setFinalValues();
            return;
          }

          this.numbers.forEach((number, metricIndex) => this.buildReels(number, metricIndex));

          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.play();
                this.observer.disconnect();
              }
            },
            { threshold: 0.28, rootMargin: '0px 0px -8% 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.animationFrame && cancelAnimationFrame(this.animationFrame);
          this.timers?.forEach((timer) => clearTimeout(timer));
        }

        setFinalValues() {
          this.dataset.state = 'settled';
          this.numbers.forEach((number) => {
            number.textContent = `${number.dataset.value}%`;
          });
        }

        play() {
          if (this.hasPlayed) return;
          this.hasPlayed = true;
          this.timers = [];

          this.animationFrame = requestAnimationFrame(() => {
            this.animationFrame = requestAnimationFrame(() => {
              this.dataset.state = 'rolling';
            });
          });

          const settleTimer = setTimeout(() => this.settle(), 1700);
          this.timers.push(settleTimer);
        }

        buildReels(number, metricIndex) {
          const digits = String(Number(number.dataset.value)).split('');
          const fragment = document.createDocumentFragment();

          digits.forEach((targetDigit, digitIndex) => {
            const reel = document.createElement('span');
            const track = document.createElement('span');
            const delay = (metricIndex * 90) + (digitIndex * 85);

            reel.className = 'noxtee-clinical-proof__reel';
            reel.style.setProperty('--reel-delay', `${delay}ms`);
            reel.style.setProperty('--reel-duration', `${1180 + (digitIndex * 90)}ms`);
            track.className = 'noxtee-clinical-proof__reel-track';

            for (let cycle = 0; cycle < 3; cycle += 1) {
              for (let digit = 0; digit <= 9; digit += 1) {
                track.append(this.createDigit(digit));
              }
            }

            track.append(this.createDigit(targetDigit));
            reel.append(track);
            fragment.append(reel);
          });

          const suffix = document.createElement('span');
          suffix.className = 'noxtee-clinical-proof__suffix';
          suffix.textContent = '%';
          suffix.style.setProperty('--suffix-delay', `${980 + (metricIndex * 90)}ms`);
          fragment.append(suffix);

          number.replaceChildren(fragment);
        }

        createDigit(value) {
          const digit = document.createElement('span');
          digit.className = 'noxtee-clinical-proof__reel-digit';
          digit.textContent = value;
          return digit;
        }

        settle() {
          this.numbers.forEach((number) => {
            number.textContent = `${number.dataset.value}%`;
          });
          this.dataset.state = 'settled';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtee-editorial-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nx-footer-language]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  const footerDesktopQuery = window.matchMedia('(min-width: 750px)');

  document.querySelectorAll('[data-nx-footer-menu]').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    const syncExpandedState = () => summary.setAttribute('aria-expanded', String(details.open));
    const syncBreakpoint = () => {
      details.open = true;
      syncExpandedState();
    };

    summary.addEventListener('click', (event) => {
      if (footerDesktopQuery.matches) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      details.open = !details.open;
      syncExpandedState();
    });

    details.addEventListener('toggle', syncExpandedState);
    footerDesktopQuery.addEventListener('change', syncBreakpoint);
    syncBreakpoint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtee-home-benefit-selector"] && !Shopify.designMode) return;
  try {
    
  const initializeNoxteeHomeBenefits = (root = document) => {
    root.querySelectorAll('[data-nx-home-benefits]').forEach((section) => {
      if (section.dataset.nxReady === 'true') return;
      const tabs = [...section.querySelectorAll('[data-nx-benefit-tab]')];
      const panels = [...section.querySelectorAll('[data-nx-benefit-panel]')];
      const activate = (nextTab) => {
        tabs.forEach((tab, index) => {
          const selected = tab === nextTab;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          panels[index].hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next]);
          tabs[next].focus();
        });
      });
      section.dataset.nxReady = 'true';
    });
  };
  document.addEventListener('shopify:section:load', (event) => initializeNoxteeHomeBenefits(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeNoxteeHomeBenefits());
  else initializeNoxteeHomeBenefits();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtee-mechanism-explainer"] && !Shopify.designMode) return;
  try {
    
  class NoxteeMechanism extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video')];
      if (!this.videos.length) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reducedMotion) {
        this.videos.forEach((video) => video.pause());
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.3 });

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('noxtee-mechanism')) {
    customElements.define('noxtee-mechanism', NoxteeMechanism);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtee-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noxtee-sale-countdown')) {
    customElements.define(
      'noxtee-sale-countdown',
      class extends HTMLElement {
        connectedCallback() {
          if (this.intervalId) return;

          const duration = Number(this.dataset.durationSeconds || 7200) * 1000;
          const storageKey = this.dataset.storageKey || 'noxtee-sale-countdown';
          let deadline = 0;

          try {
            deadline = Number(sessionStorage.getItem(storageKey));
            if (!deadline) {
              deadline = Date.now() + duration;
              sessionStorage.setItem(storageKey, String(deadline));
            }
          } catch (_error) {
            deadline = Date.now() + duration;
          }

          this.hoursElement = this.querySelector('[data-countdown-hours]');
          this.minutesElement = this.querySelector('[data-countdown-minutes]');
          this.secondsElement = this.querySelector('[data-countdown-seconds]');

          const update = () => {
            const remaining = Math.max(0, deadline - Date.now());
            const totalSeconds = Math.ceil(remaining / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            this.hoursElement.textContent = String(hours).padStart(2, '0');
            this.minutesElement.textContent = String(minutes).padStart(2, '0');
            this.secondsElement.textContent = String(seconds).padStart(2, '0');
            this.querySelector('[role="timer"]')?.setAttribute(
              'aria-label',
              `${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`
            );

            if (remaining <= 0 && this.intervalId) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          };

          update();
          this.intervalId = window.setInterval(update, 1000);
        }

        disconnectedCallback() {
          if (this.intervalId) clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxtee-weekly-journey"] && !Shopify.designMode) return;
  try {
    
  class NoxteeWeeklyJourney extends HTMLElement {
    connectedCallback() {
      this.milestones = [...this.querySelectorAll('[data-weekly-milestone]')];
      this.timeline = this.querySelector('[data-weekly-timeline]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setScrollRoot();
      this.queued = false;
      this.handlePosition = this.handlePosition.bind(this);
      this.handleResize = this.handleResize.bind(this);

      if (this.reducedMotion) {
        this.milestones.forEach((milestone) => {
          milestone.style.setProperty('--reveal', '1');
          milestone.style.setProperty('--line-reveal', '1');
          milestone.style.setProperty('--item-opacity', '1');
          milestone.style.setProperty('--item-offset', '0');
          milestone.style.setProperty('--label-offset', '0.18rem');
          milestone.classList.add('is-active');
        });
        return;
      }

      this.scrollRoot.addEventListener('scroll', this.handlePosition, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.handlePosition();
    }

    disconnectedCallback() {
      this.scrollRoot?.removeEventListener('scroll', this.handlePosition);
      window.removeEventListener('resize', this.handleResize);
    }

    setScrollRoot() {
      const candidate = this.closest('.page-wrapper');
      const candidateStyle = candidate ? getComputedStyle(candidate) : null;
      const isScrollable = candidate
        && candidate.scrollHeight > candidate.clientHeight
        && ['auto', 'scroll'].includes(candidateStyle.overflowY);

      this.scrollRoot = isScrollable ? candidate : window;
    }

    handleResize() {
      const previousRoot = this.scrollRoot;
      this.setScrollRoot();

      if (previousRoot !== this.scrollRoot) {
        previousRoot.removeEventListener('scroll', this.handlePosition);
        this.scrollRoot.addEventListener('scroll', this.handlePosition, { passive: true });
      }

      this.handlePosition();
    }

    handlePosition() {
      if (this.queued) return;
      this.queued = true;

      requestAnimationFrame(() => {
        const isWindowRoot = this.scrollRoot === window;
        const rootRect = isWindowRoot ? { top: 0 } : this.scrollRoot.getBoundingClientRect();
        const rootHeight = isWindowRoot ? window.innerHeight : this.scrollRoot.clientHeight;
        const activationLine = rootRect.top + (rootHeight * 0.68);
        const dotCenters = this.milestones.map((milestone) => {
          const dot = milestone.querySelector('.noxtee-weekly-journey__dot');
          const dotRect = dot.getBoundingClientRect();
          return dotRect.top + (dotRect.height / 2);
        });

        this.milestones.forEach((milestone, index) => {
          const dotCenter = dotCenters[index];
          const nextDotCenter = dotCenters[index + 1] ?? dotCenter + Math.min(rootHeight * 0.2, 150);
          const revealDistance = Math.max(72, Math.min(130, (nextDotCenter - dotCenter) * 0.48));
          const reveal = this.clamp((activationLine - dotCenter) / revealDistance);
          const lineReveal = index === this.milestones.length - 1
            ? reveal
            : this.clamp((activationLine - dotCenter) / (nextDotCenter - dotCenter));

          milestone.style.setProperty('--reveal', reveal.toFixed(3));
          milestone.style.setProperty('--line-reveal', lineReveal.toFixed(3));
          milestone.style.setProperty('--item-opacity', (0.42 + (reveal * 0.58)).toFixed(3));
          milestone.style.setProperty('--item-offset', `${((1 - reveal) * 0.55).toFixed(3)}rem`);
          milestone.style.setProperty('--label-offset', `${(reveal * 0.18).toFixed(3)}rem`);
          milestone.classList.toggle('is-active', reveal >= 0.98);
        });

        this.queued = false;
      });
    }

    clamp(value) {
      return Math.min(1, Math.max(0, value));
    }
  }

  if (!customElements.get('noxtee-weekly-journey')) {
    customElements.define('noxtee-weekly-journey', NoxteeWeeklyJourney);
  }

  } catch(e) { console.error(e); }
})();
})();
